import { createFileRoute, redirect } from '@tanstack/react-router';

/**
 * `/users` — «Gestione utenti» non c'è più (01-11-2026).
 *
 * Elenco, filtri, stato delle utenze e ruoli stanno in «Utenti e ruoli» › Persone
 * (`/organization/permissions`), che legge tutta l'azienda e pagina in memoria. Restano la scheda
 * utente (`/users/$userId`), aperta dalla riga di una persona, e l'invito (`/users/new`), aperto da
 * «Invita un esterno». L'indirizzo resta come rinvio, per i preferiti e i collegamenti salvati.
 *
 * Nessuno ha perso l'accesso: «Gestione utenti» senza «Utenti e ruoli» l'apriva solo il ruolo storico
 * Admin, che si elimina (task 3576). «Importa Excel» puntava a `/users/import`, che non è mai esistita.
 */
export const Route = createFileRoute('/_app/users/')({
  beforeLoad: () => { throw redirect({ to: '/organization/permissions', replace: true }); },
});
